export enum PlatformEnum {
  GCP = 'GCP',
  AWS = 'AWS',
  UNKNOWN = 'UNKNOWN',
}

export type CustomerPlatformStore = {
  customerPlatform: PlatformEnum;
};
